var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "projects-card transition delay-75 duration-150" },
    [
      _c("div", { staticClass: "flex flex-row justify-between h-7" }, [
        _c(
          "div",
          [
            !_vm.hasUnconfirmedHours && _vm.project.completed
              ? _c("Badge", {
                  staticClass: "text-badge capitalize",
                  attrs: {
                    color: _vm.BadgeColor.INFO,
                    value: "Closed",
                    styleClasses: "py-0.5 px-2",
                  },
                })
              : _vm._e(),
            _vm.project.drafted && !_vm.project.completed
              ? _c("Badge", {
                  attrs: {
                    value: "Draft",
                    color: _vm.BadgeColor.Draft,
                    styleClasses:
                      "text-storm-gray bg-gray-tabs capitalize customBadgeWidth py-0.5 px-2",
                  },
                })
              : _vm._e(),
            !_vm.project.completed && !_vm.project.drafted
              ? _c("Badge", {
                  staticClass: "capitalize text-badge",
                  attrs: {
                    color: _vm.BadgeColor.ACTIVE,
                    styleClasses: "py-0.5 px-2",
                    value: "Active",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        !_vm.project.completed
          ? _c(
              "div",
              { staticClass: "flex flex-row items-center" },
              [
                _vm.hasParticipants
                  ? _c("MessageAction", {
                      attrs: {
                        companyId: _vm.companyId,
                        currentUser: _vm.currentUser,
                        groupConversationUsers: _vm.projectUsers,
                        project: _vm.project,
                      },
                    })
                  : _vm._e(),
                _c("AddTaskAction", {
                  attrs: {
                    projectId: _vm.project.id,
                    project: _vm.project,
                    companyId: _vm.companyId,
                    currentUser: _vm.currentUser,
                    currentUserRole: _vm.currentUser.role,
                  },
                }),
                _c("EditProjectAction", {
                  attrs: {
                    project: _vm.project,
                    currentUser: _vm.currentUser,
                    companyId: _vm.companyId,
                  },
                  on: {
                    projectUpdated: function ($event) {
                      return _vm.$emit("projectUpdated")
                    },
                  },
                }),
              ],
              1
            )
          : _c("div"),
      ]),
      _c(
        "div",
        { staticClass: "project-name focus:!outline-none" },
        [
          _c(
            "RouterLink",
            {
              staticClass:
                "block hover:text-primary cursor-pointer focus!:outline-none",
              attrs: { to: _vm.projectActivitiesPageRoute },
            },
            [
              _vm._t("default", function () {
                return [_vm._v(" " + _vm._s(_vm.project.client_name) + " ")]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c("div"),
      _c("div", { staticClass: "dateCreated" }, [
        _vm._v(" Date created: " + _vm._s(_vm.createdAt) + " "),
      ]),
      _c("div", { staticClass: "location" }, [
        _c(
          "div",
          { staticClass: "flex flex-row gap-1 min-h-9" },
          [
            _c("CalendarIcon", { staticClass: "w-4 h-4 mr-1" }),
            _vm.location
              ? _c(
                  "a",
                  {
                    staticClass: "text-blue text-sm font-400 hover:underline",
                    attrs: {
                      href: _vm.googleMapsLink,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.location) + " ")]
                )
              : _c("p", { staticClass: "text-blue text-sm font-400" }, [
                  _vm._v("n/a"),
                ]),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "flex gap-1 w-full items-center mt-3" },
        [
          _c("span", { staticClass: "team-teams" }, [_vm._v("Manager:")]),
          this.project.manager !== null && this.project.manager.user
            ? _c("RouterLink", { attrs: { to: _vm.managerRoute } }, [
                _c("div", { staticClass: "flex flex-row gap-1" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "manager-chips flex flex-row items-center text-left",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "rounded-full flex items-center text-xs flex-shrink-0 justify-center text-white manager-image hover:text-white hover:border-primary-500",
                          style: _vm.bgStyle,
                        },
                        [_vm._v(" " + _vm._s(_vm.initial) + " ")]
                      ),
                      _vm._v(
                        " " +
                          _vm._s(this.project.manager.user.given_name) +
                          " " +
                          _vm._s(this.project.manager.user.family_name) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ])
            : _c("div", { staticClass: "manager" }, [_vm._v(" n/a ")]),
        ],
        1
      ),
      _c("div", { staticClass: "action-section mt-2" }, [
        _c(
          "div",
          { staticClass: "relative flex flex-row p-1 pb-0 items-center" },
          [
            _c("hr"),
            _c("div", { staticClass: "flex flex-col items-center w-full" }, [
              _c("div", { staticClass: "projects-value" }, [
                _vm._v(_vm._s(_vm.totalActivities)),
              ]),
              _c("div", { staticClass: "projects-name" }, [
                _vm._v("Scheduled visits"),
              ]),
            ]),
            _c("div", { staticClass: "flex flex-col items-center w-full" }, [
              _c("div", { staticClass: "projects-value" }, [
                _vm._v(_vm._s(_vm.unassignedVisit)),
              ]),
              _c("div", { staticClass: "projects-name" }, [
                _vm._v("Unassigned visits"),
              ]),
            ]),
          ]
        ),
      ]),
      _c(
        "div",
        {
          staticClass:
            "flex flex-col w-full items-center bg-white border-t border-gray-200 adjustFlexWidth",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex gap-1 w-full skills-footer items-start items-center",
            },
            [
              _vm._v(" Tags: "),
              _vm.uniqueSkills.length > 0
                ? _c(
                    "div",
                    { staticClass: "flex flex-row gap-1 items-center" },
                    [
                      _vm._l(_vm.uniqueSkills.slice(0, 3), function (skill) {
                        return _c(
                          "div",
                          { key: skill.skill.name, staticClass: "skills-chip" },
                          [_vm._v(" " + _vm._s(skill.skill.name) + " ")]
                        )
                      }),
                      _vm.uniqueSkills.length > 3
                        ? _c("div", [
                            _c("div", { staticClass: "skills-chip-plus" }, [
                              _vm._v("+" + _vm._s(_vm.uniqueSkills.length - 3)),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.uniqueSkills.length === 0 || _vm.uniqueSkills === undefined
                ? _c("div", { staticClass: "notAvaialble" }, [_vm._v("n/a")])
                : _vm._e(),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }